<ion-content class="ion-color-medium">
  <ion-slides pager="true" #slides class="info-slider">
    <!-- FIRST SLIDE -->
    <ion-slide>
      <ion-card class="ion-no-margin">
        <ion-card-header class="intro-logo">
          <img
            src="/assets/imgs/header-icon-green.png"
            class="ion-padding-top"
          />
          <!--<ion-card-subtitle>Willkommen</ion-card-subtitle>-->
          <ion-card-title class="ion-padding-top">
            <ion-icon name="leaf" color="success"></ion-icon>
            Welcome to the Green CoCo Community!
            <ion-icon name="leaf" color="success"></ion-icon>
          </ion-card-title>
        </ion-card-header>

        <ion-row>
          <ion-col>
            <ion-button color="primary" (click)="next()">
              GET STARTED
              <ion-icon slot="end" name="chevron-forward-outline"></ion-icon>
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-card>
    </ion-slide>

    <!-- SECOND SLIDE -->
    <ion-slide>
      <ion-card class="ion-no-margin">
        <ion-card-header class="intro-logo">
          <img src="/assets/imgs/batami_kresse.png" class="ion-padding-top" />
          <ion-card-subtitle>Batami View</ion-card-subtitle>
          <!-- <ion-card-title>Connection & Community</ion-card-title> -->
        </ion-card-header>

        <ion-card-content>
          <ion-item lines="none">
            <ion-text>
              Kennst du Tamagotchis? Ja? Super! Nein? Egal, wir zeigen dir was
              viel besserers.
            </ion-text>
          </ion-item>
          <ion-item lines="none">
            <ion-label>
              <b> Reallife Pflanzen-Tamagotchi </b>
            </ion-label>
          </ion-item>
          <ion-item lines="none">
            <ion-text>
              Bei uns ist dein Tamagotchi eine lebende Pflanze, die gepflegt und
              geliebt werden möchte. Durch die digitale Überwachung der Pflanze
              mithilfe von Sensoren und Mikrocontrollern wird ein digitales
              Abbild der Pflanze erschaffen, welches du dadurch immer bei dir
              tragen kannst.
            </ion-text>
          </ion-item>
          <ion-item lines="none">
            <ion-label>
              <b>
                Batami
                <ion-icon name="leaf" color="success"></ion-icon>
              </b>
            </ion-label>
          </ion-item>
          <ion-item lines="none">
            <ion-text>
              Wir nennen dein digitales Abbild der Pflanze <b>Batami</b>. Dein
              Batami sieht beispielsweise so aus, wie oben auf dem Bild. Je nach
              Pflanzentyp unterscheidet sich allerdings der Kopf.
            </ion-text>
          </ion-item>
          <ion-item lines="none" style="margin-bottom: -1rem">
            <ion-label>
              <b> Was wird überwacht? </b>
            </ion-label>
          </ion-item>
          <ion-item lines="none">
            <ion-text>
              <ul>
                <li>
                  Temperatur
                  <ion-icon name="thermometer" color="danger"></ion-icon>
                </li>
                <li>
                  Luftfeuchtigkeit
                  <ion-icon name="sunny" color="warning"></ion-icon>
                  <ion-icon name="rainy"></ion-icon>
                </li>
                <li>
                  Erdfeuchte
                  <ion-icon name="water" color="primary"></ion-icon>
                </li>
              </ul>
            </ion-text>
          </ion-item>
        </ion-card-content>

        <ion-row>
          <ion-col>
            <ion-button color="secondary" fill="outline" (click)="prev()">
              <ion-icon slot="start" name="chevron-back-outline"></ion-icon>
              Zurück
            </ion-button>
          </ion-col>

          <ion-col>
            <ion-button color="primary" (click)="next()">
              NEXT
              <ion-icon slot="end" name="chevron-forward-outline"></ion-icon>
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-card>
    </ion-slide>

    <!-- THIRD SLIDE -->
    <ion-slide>
      <ion-card class="ion-no-margin">
        <ion-card-header class="intro-logo">
          <img src="/assets/imgs/forest.png" class="ion-padding-top" />
          <ion-card-subtitle>Forest View</ion-card-subtitle>
          <!-- <ion-card-title>Forest View</ion-card-title> -->
        </ion-card-header>

        <ion-card-content>
          <ion-item lines="none">
            <ion-label>
              <b>
                Community
                <ion-icon name="people" color="primary"></ion-icon>
              </b>
            </ion-label>
          </ion-item>
          <ion-item lines="none">
            <ion-text>
              Das schöne ist, du kannst deinen Batami mit jemand anderem teilen,
              wenn du möchtest. Dann könnt ihr euch zusammen um die Pflanze
              kümmern.
            </ion-text>
          </ion-item>
          <ion-item lines="none">
            <ion-text>
              Noch schöner ist: Du kannst auch alle anderen Batamis und deren
              Zustand sehen. Sollte eine andere Pflanze mal vernachlässigt
              werden, kannst du dem zugehörigen Team unter die Arme greifen.
            </ion-text>
          </ion-item>
          <ion-item lines="none">
            <ion-label>
              <b> Einfluss auf die Community? </b>
            </ion-label>
          </ion-item>
          <ion-item lines="none">
            <ion-text>
              Insbesondere der Forest-View, also die Ansicht aller Batamis,
              dient als Indikator und Visualisierung des Wohlbefinden der
              Community. Hält beispielsweise ein intensives Studienmodul das
              Team davon ab der Pflanze die nötige Aufmerksamkeit zu schenken,
              spiegelt der Batami die Belastung im Teams wieder. Gleichzeitig
              regt die Transparenz im Batami-Forest die gegenseitige
              Unterstützung innerhalb der Community an. Es kann sich
              ausgetauscht aber auch unterstützt und geholfen werden.
            </ion-text>
          </ion-item>
        </ion-card-content>

        <ion-row>
          <ion-col>
            <ion-button color="secondary" fill="outline" (click)="prev()">
              <ion-icon slot="start" name="chevron-back-outline"></ion-icon>
              Zurück
            </ion-button>
          </ion-col>
          <ion-col>
            <ion-button color="primary" (click)="next()">
              NEXT
              <ion-icon slot="end" name="chevron-forward-outline"></ion-icon>
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-card>
    </ion-slide>

    <!-- FOURTH SLIDE -->
    <ion-slide>
      <ion-card class="ion-no-margin">
        <ion-card-header class="intro-logo">
          <img src="/assets/imgs/howto.png" class="ion-padding-top" />
        </ion-card-header>
        <ion-row>
          <ion-col>
            <ion-button color="secondary" fill="outline" (click)="prev()">
              <ion-icon slot="start" name="chevron-back-outline"></ion-icon>
              Wie war das nochmal?
            </ion-button>
          </ion-col>
          <ion-col>
            <ion-button color="primary" (click)="dismissModal()">
              Probier es aus
              <ion-icon slot="end" name="exit-outline"></ion-icon>
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-card>
    </ion-slide>
  </ion-slides>
</ion-content>
